//私钥
const PRIVATEKEY = "8a4af424bd714be5b2baacbe3cf5bbbe0131effeb92e99356ef1662884558f28"

export{
	PRIVATEKEY
}
